import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "reactstrap";
import { EmptyRequestState, RequestState } from "../../../../models/RequestState";
import { DeleteClassroom } from "../../../../store/ClassroomAdmin/ClassroomToolsAction";
import { RootState } from "../../../../store/store";
import StatusCode from "../../../../util/StatusCode";
import Loading from "../../../misc/Loading";
import { CoreClassroomAdminClassroom } from "../../../../models/CoreClassroomAdminClassroom";


const ClassroomViewToolDeleteClassroom = () => {
    const { t } = useTranslation(['common', "classroomAdmin"]);
    const dispatch = useDispatch();

    const [confirm, setConfirm] = useState<boolean>(false);
    const deleteClassroomState = useSelector<RootState, EmptyRequestState>(x => x.classroomTools.deleteClassroom);
    const classroom = useSelector<RootState, RequestState<CoreClassroomAdminClassroom>>(x => x.classroomAdminClassroom.classroom);


    const deleteClassroom = () => {
        setConfirm(true);
        if (classroom.code === StatusCode.COMPLETE && classroom.data) {
            DeleteClassroom(classroom.data.classroomId)(dispatch);
        };
    };

    if (!confirm) {
        return (
            <div>
                <p>{t(`tools.DELETE_CLASSROOM.confirmText`, { ns: 'classroomAdmin' })}</p>
                <Button onClick={() => deleteClassroom()}>{t('yes', { ns: 'common' })}</Button>
            </div>
        )
    }
    if (deleteClassroomState.code === StatusCode.PENDING) {
        return <Loading />;
    }
    if (deleteClassroomState.code === StatusCode.ERROR) {
        if (deleteClassroomState?.error?.response?.status === 404) {
            return t(`tools.DELETE_CLASSROOM.notFound`, { ns: 'classroomAdmin' })
        }
        return t(`tools.DELETE_CLASSROOM.error`, { ns: 'classroomAdmin' })
    }
    if (deleteClassroomState.code === StatusCode.COMPLETE) {
        return t(`tools.DELETE_CLASSROOM.success`, { ns: 'classroomAdmin' })
    }
}

export default ClassroomViewToolDeleteClassroom;
